export const TOKEN = 'token';
export const EXP = 'exp';
export const LOCALSTORAGE_AUTH_KEY = 'prestadores_smg_auth';
export const USER_DATA = 'user_data';
export const USER_PERMISSIONS = 'user_permissions';
export const USER_HAS_ACCEPTED_TERMS = 'userHasAcceptedTerms';
export const USER_HAS_DOC24_PERMISSION = 'userHasDOC24Permission';
export const USER_SURVEY_RESPONSE = 'userSurveyResponse';
export const USER_IS_CIRCLE = 'is_circle';
export const USER_MANAGEMENT_UNITS = 'managementUnit';
export const HOSPITALIZATION_AFFILIATE_VALIDATION = 'hospitalizationInAffiliateValidation';
